"use strict";

define('components/modal',['components/ajax', 'components/dom_setup'], function(ajax, domSetup) {
    function setError(errorMsg) {
        // Hide the form, and show any errors.
        $('#upload-form').removeClass('hidden');
        $('#upload-status').addClass('hidden');
        var errorDiv = $('#upload-error-div');
        errorDiv.removeClass('hidden');
        errorDiv.find('.upload-error-msg').text(errorMsg);
    }

    var modal = {

        init: function(node) {
            var self = this;
            node.find('.modal:not(.unmanaged-modal)').on('loaded.bs.modal', function(e) {
                self.modalLoaded($(this), e);
            });

            node.find('.modal:not(.unmanaged-modal)').on('hidden.bs.modal', function(e) {
                $(this).removeData('bs.modal');
                $(this).find('.modal-content').empty()
            });

            node.find('.modal:not(.unmanaged-modal)').on('shown.bs.modal', function(e) {
                require('components/form').focusFirstInput($(this));
                $(this).on('jsq:modalHide', function(e){
                    $(this).modal('hide');
                });
            });

            node.find('#initial-modal-content').load(node.find('#initial-modal-content').data('url'), function() {
                node.find('#initial-modal-wrapper').modal('show');
            });

            // Click handler for buttons that trigger the waiting modal
            node.find('.waiting-modal').click(function(e) {
                var modalNode = $('#waiting-modal');
                if (modalNode.length != 0) {
                    modalNode.find('.modal-title>span').text($(e.target).data('waiting-title'));
                    modalNode.find('.modal-body').text($(e.target).data('waiting-body'));
                    modalNode.modal('show');
                }
            });

            node.find('.nda-block').click(function(e){
                e.preventDefault();
                var button = $(this);
                var url = $(this).attr('href');
                $.ajax({
                    url: url,
                    type: 'GET',
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    success: function(result) {
                        if (result.status != 'ok') {
                            return;
                        }
                        if (result.download) {
                            window.location = result.download;
                            return;
                        }

                        var modalSel = button.data('modal-target');
                        var modalNode = $(modalSel);
                        modalNode.find('.modal-content').html(result.body);
                        modalNode.modal({
                            'backdrop': 'static',
                        });
                        self.modalLoaded(modalNode);
                    },
                });
            });
        },

        modalLoaded: function(modalNode, e) {
            // Initialize the modal component if one was specified
            var modalBody = modalNode.find('.modal-body');
            if (modalBody.length == 0) {
                modalBody = modalNode.find('.lightbox-body');
            }
            var modalComponentName = modalBody.data('modal-component');
            if (modalComponentName && modalComponentName !== 'editor') {
                require(['components/'+modalComponentName], function(component) {
                    component.init(modalNode);
                });
            }
            // Initialize the pillar component if it's the TinyMCE Editor
            var moduleComponentName = modalBody.children().data('module-component');
            if (moduleComponentName === 'editor' && typeof window.__jsqRenderPillars__ === "function") {
                window.__jsqRenderPillars__();
            }

            // Prevent drop-file in the dialog
            modalNode.bind('drop dragover dragenter', function (e) {
                e.preventDefault();
            });

            // Initialize components on the form
            domSetup.init(modalNode.find('.modal-content'));

            // If the modal contains a form, its contents may change and grow the height of the modal.  If the
            // the modal height grows to be larger than the viewport height, bootstrap does not automatically
            // grow the backdrop.  Register for updates to the form and explicitly resize the backdrop on update.
            var formNode = modalBody.find('form');
            if (formNode.length > 0) {
                formNode.on('jsq:formContentChanged', function(e) {
                    modalNode.modal('handleUpdate');
                });
            }

            var self = this;

            // Bind the form-submit to the dialog's 'Save' button (not part of the form).
            //
            // Notice that you can specify "data-show-spinner-on-submit" if you know that processing the submission may
            // take a while.
            if (modalNode.attr('data-prevent-default-submit') != 'true') {
                modalNode.find('button[data-save-url]').each(function(){
                    // This option submits the form and hides the modal
                    $(this).click(function(e){
                        self.submitClickHandler(modalNode, modalBody, $(this))
                    });
                });
            }

            modalNode.find('button[data-preview-url]').each(function(){
                // This option previews the pdf with watermark
                $(this).click(function(e){
                    self.previewClickHandler(modalNode, modalBody, $(this))

                });
            });

            // Use submit-link class for hyperlinks that work as "submit" and
            // are not instantaneous to the user
            modalNode.find('a.submit-link').click(function() {
                // "loading" overlay on the modal prior to navigating away
                self._addSpinner(modalNode);
            });

            modalNode.find('button[data-save-event]').each(function(){
                // This option simply fires the event and does NOT hide the modal - thats the responsibility
                // of the event handler.
                var submitEvent = $(this).data('save-event');
                $(this).click(function(e){
                    var formNode = modalBody.find('form:visible');
                    formNode.trigger(submitEvent, formNode);
                });
            });

            modalNode.find('#send_invitation_emails-generate-data-room-links-and-send-invitation-emails').click(function(e){
                if ($(this).is(':checked'))  {
                    modalNode.find('.warning-box-link-portal-email').removeClass('hidden');
                    modalNode.find('.warning-box-link-no-subscription').addClass('hidden');
                    modalNode.find('.warning-box-link-yes-subscription').addClass('hidden');
                }
            });

            modalNode.find('#send_invitation_emails-generate-data-room-links-only').click(function(e){
                if ($(this).is(':checked'))  {
                    modalNode.find('.warning-box-link-portal-email').addClass('hidden');
                    if (modalNode.find('#no-create-subscription-package').is(':checked')) {
                        modalNode.find('.warning-box-link-no-subscription').removeClass('hidden');
                    }
                    else if (modalNode.find('#yes-create-subscription-package').is(':checked')) {
                        modalNode.find('.warning-box-link-yes-subscription').removeClass('hidden');
                    }
                }
            });

            modalNode.find('#no-create-subscription-package').click(function(e){
                if ($(this).is(':checked'))  {
                    if (modalNode.find('#send_invitation_emails-generate-data-room-links-only').is(':checked')) {
                        modalNode.find('.warning-box-link-no-subscription').removeClass('hidden');
                        modalNode.find('.warning-box-link-yes-subscription').addClass('hidden');
                    }
                }
            });

            modalNode.find('#yes-create-subscription-package').click(function(e){
                if ($(this).is(':checked'))  {
                    if (modalNode.find('#send_invitation_emails-generate-data-room-links-only').is(':checked')) {
                        modalNode.find('.warning-box-link-yes-subscription').removeClass('hidden');
                        modalNode.find('.warning-box-link-no-subscription').addClass('hidden');
                    }
                }
            });
        },

        previewClickHandler: function(modalNode, modalBody, previewButton) {
            var formNode = modalBody.find('form');
            var previewUrl = previewButton.data('preview-url');

            // Add overlay and spinner
            var addWatermarkPreviewOverlay = '<div class="module-overlay"><img src="/static/spinner_sm.gif" width="16" height="16"></div>';
            modalNode.find('.modal-content').prepend(addWatermarkPreviewOverlay);

            if (formNode.length > 0) {
                this._previewWatermark(
                    modalNode, modalBody, formNode, previewUrl, previewButton);
            } else {
                this._previewWatermark(modalNode, modalBody, null, previewUrl, previewButton);
            }
        },

        _previewWatermark: function(modalNode, modalBody, formNode, url, previewButton) {
            var formData = formNode ? require('components/form').serialize(formNode) : null;
            $('#upload-form').addClass('hidden');
            previewButton.addClass('disabled');
            
            require(['components/preview_watermark_utils'], function(previewWatermarkUtils) {
                previewWatermarkUtils.handlePreview({
                    previewUrl: url,
                    formData: formData,
                    modalOptions: {
                        modalId: 'preview-pdf-modal',
                        modalBodyHeight: '680px'
                    },
                    beforePreview: function() {
                        $('#upload-form').addClass('hidden');
                        previewButton.addClass('disabled');
                    },
                    onModalClose: function() {
                        previewButton.removeClass('disabled')
                            .prop('disabled', false);
                        modalNode.find('.module-overlay').remove();
                    },
                    onPreviewFailure: function(result) {
                        previewButton.removeClass('disabled')
                            .prop('disabled', false);
                        modalNode.find('.module-overlay').remove();
                        if (result.error_message) {
                            setError(result.error_message);
                        } else {
                            modalBody.html(result.body);
                            domSetup.init(modalBody);
                        }
                    },
                    onPreviewError: function(result) {
                        previewButton.removeClass('disabled')
                            .prop('disabled', false);
                        modalNode.find('.module-overlay').remove();
                        if (result.state() === 'rejected') {
                            setError('Documents could not upload because the file is invalid.');
                        }
                    }
                });
            });
        },

        submitClickHandler: function(modalNode, modalBody, submitButton) {
            var formNode = modalBody.find('form');
            var submitUrl = submitButton.data('save-url');

            // If the modal contains a form, then serialize its contents
            var showSpinnerOnSubmit = submitButton.data('show-spinner-on-submit') === "True";
            if (formNode.length > 0) {
                this._submitForm(
                    modalNode, modalBody, formNode, submitUrl, submitButton, showSpinnerOnSubmit);
            } else {
                // submitForm hides the modal on success
                this._submitForm(modalNode, modalBody, null, submitUrl, submitButton, showSpinnerOnSubmit);
            }
        },

        _submitForm: function(modalNode, modalBody, formNode, url, submitButton, showSpinnerOnSubmit) {

            var self = this;
            if (showSpinnerOnSubmit) {
                self._addSpinner(modalNode);
            }
            $('#upload-form').addClass('hidden');
            var corruptedFileDiv = $('#corrupted-error-div');
            corruptedFileDiv.addClass('hidden');
            submitButton.addClass('disabled');
            ajax(url, {
                formData: formNode ? require('components/form').serialize(formNode) : null,
                onSuccess: function(result) {
                    if (showSpinnerOnSubmit) {
                        self._removeSpinner(modalNode);
                    }
                    modalNode.modal('hide');
                    $(document).trigger('jsq:modalSuccess', [result]);

                    if (result.download) {
                        modalNode.one('hidden.bs.modal', function(e) {
                            $(this).removeData('bs.modal');
                            $(this).find('.modal-content').empty()
                            window.location = result.download;
                        });
                    }

                    if (result && result.updates && result.updates.show_add_nda_button === false) {
                        $('#add-nda-link').addClass('hidden');
                    }

                    if (result.next_modal) {
                        modalNode.one('hidden.bs.modal', function(e) {
                            modalNode.removeData('bs.modal');
                            modalNode.find('.modal-content').load(result.next_modal.href, function() {
                                modalNode.modal({
                                    'backdrop': 'static',
                                });
                                self.modalLoaded(modalNode);
                            });
                        });
                    }

                    return false;  // dont prevent default ajax response processing
                },
                onFailure: function(result) {
                    if (showSpinnerOnSubmit) {
                        self._removeSpinner(modalNode);
                    }
                    if (result.error_message && result.status === "corruption_error") {
                        var corruptedFileDiv = $('#corrupted-error-div');
                        corruptedFileDiv.removeClass('hidden');
                        corruptedFileDiv.find('.corrupted-error-msg').text("This file is corrupted");
                        corruptedFileDiv.find('.corrupted-error-file-message').text("The file appears to be corrupted. Try uploading it again or use a different file format.");
                        $('#upload-form').removeClass('hidden');
                        $('#upload-status').addClass('hidden');
                    }
                    else if(result.error_message){
                        setError(result.error_message);
                    } else {
                        modalBody.html(result.body);
                        domSetup.init(modalBody);
                    }
                    modalNode.trigger('shown.bs.modal');
                    submitButton.removeClass('disabled');
                    var modalComponentName = modalBody.data('modal-component');
                    if (modalComponentName) {
                        require(['components/'+modalComponentName], function(component) {
                            component.init(modalBody);
                        });
                    }
                },
                onError: function(result) {
                    if (result.state() === 'rejected') {
                        setError('Documents could not upload because the file is invalid.');
                    }
                    if (showSpinnerOnSubmit) {
                        self._removeSpinner(modalNode);
                    }
                    submitButton.removeClass('disabled');
                }
            });
        },

        _addSpinner: function(modalNode) {
            modalNode
                .find('.modal-content')
                .prepend('<div class="module-overlay"><img src="/static/spinner_lg.gif" width="24" height="24"/></div>');
        },

        _removeSpinner: function(modalNode) {
            modalNode.find('.modal-content .module-overlay').addClass('hidden');
        },
    };

    return modal;

});   


